export default __webpack_public_path__ + "static/media/img_4.ec4c8645.png";